import { GenerationPresetErrorType, SCError, UserSettingsErrorType } from "@next-platform/packages-ts-types";
import { useTranslation } from "../../localization/hooks";
const { ERROR_CODE_PREFIX } = SCError || {};
// eslint-disable-next-line id-length -- matches useTranslation().t; literal t("error:userSettings.…") keys for grep / i18n extractors
const getNonContextUserSettingsErrors = (t) => ({
    [`${ERROR_CODE_PREFIX}-${UserSettingsErrorType.SETTING_UPDATE_FAILED}`]: t("error:userSettings.settingUpdateFailed"),
    // Generation Preset Errors
    [`${ERROR_CODE_PREFIX}-${GenerationPresetErrorType.GENERATION_PRESET_NOT_FOUND}`]: t("error:userSettings.generationPresetNotFound"),
    [`${ERROR_CODE_PREFIX}-${GenerationPresetErrorType.GENERATION_PRESET_CREATE_FAILED}`]: t("error:userSettings.generationPresetCreateFailed"),
    [`${ERROR_CODE_PREFIX}-${GenerationPresetErrorType.GENERATION_PRESET_UPDATE_FAILED}`]: t("error:userSettings.generationPresetUpdateFailed"),
    [`${ERROR_CODE_PREFIX}-${GenerationPresetErrorType.GENERATION_PRESET_DELETE_FAILED}`]: t("error:userSettings.generationPresetDeleteFailed"),
    [`${ERROR_CODE_PREFIX}-${GenerationPresetErrorType.GENERATION_PRESET_LIMIT_EXCEEDED}`]: t("error:userSettings.generationPresetLimitExceeded"),
    [`${ERROR_CODE_PREFIX}-${GenerationPresetErrorType.GENERATION_PRESET_ALREADY_EXISTS}`]: t("error:userSettings.generationPresetAlreadyExists"),
});
// eslint-disable-next-line import/prefer-default-export -- named hook export matches package barrel
export function useUserSettingsErrors() {
    const { t } = useTranslation();
    const nonContextUserSettingsErrors = getNonContextUserSettingsErrors(t);
    const getMessage = ({ errorCode, fallbackMessage, skipDefaultMessage }) => {
        const nonContextError = nonContextUserSettingsErrors[errorCode];
        if (nonContextError) {
            return nonContextError;
        }
        if (skipDefaultMessage)
            return "";
        return fallbackMessage || t("error:fallbackError");
    };
    return {
        getMessage,
    };
}
